import { render } from "./BookingGuideEditor.vue?vue&type=template&id=34e8472e"
import script from "./BookingGuideEditor.vue?vue&type=script&lang=js"
export * from "./BookingGuideEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__